import { Api as http } from "@/services/Api";
import { Currency } from "@/models/Currency";
import {ArchNotify} from "@/plugins/arch-notify";

const CURRENCY_BASE_URL = "/hotel/0/dto/currency/v1";

const setCurrencyDetails = ({ commit }, details: Currency) => {
  commit("SET_DIALOG_VISIBLE", true);
  commit("SET_CURRENCY_DETAILS", details);
};

const closeDialog = ({ commit }) => {
  commit("SET_DIALOG_VISIBLE", false);
  commit("CLEAR_CURRENCY_DETAILS", new Currency());
};

const saveCurrency = async ({ commit, dispatch, state }, payload) => {
  commit("SET_LOADING_STATE", true);
  const res = await http.post(CURRENCY_BASE_URL, payload);
  dispatch("closeDialog");
  dispatch("fetchCurrencies", { take: 15, skip: 1 });
  ArchNotify({
    showClose: true,
    message: "Currency successfully saved",
    color: "success",
  });
  commit("SET_LOADING_STATE", false);
};

const deleteCurrency = async ({ commit, state, dispatch }, id: number) => {
  commit("SET_LOADING_STATE", true);
  await http.del(`${CURRENCY_BASE_URL}?id=${id}`);
  dispatch("showSuccessSnackbar", "Currency successfully saved");
  dispatch("closeDialog");
  commit("SET_LOADING_STATE", false);
};

const showSuccessSnackbar = ({ commit }, message: string) => {
  commit("SET_SNACKBAR_VISIBILITY", true);
  commit("SET_SNACKBAR_MESSAGE", message);
  commit("SET_SNACKBAR_STATUS", "success");
};

export default {
  setCurrencyDetails,
  closeDialog,
  saveCurrency,
  showSuccessSnackbar,
  deleteCurrency,
};
